export class User {
    UserName: string;
    Password: string;
    ConfirmPassword: string;
    Email: string;
    FirstName: string;
    LastName: string;
    Empresa: string;
    clienteID: number;
}
export class UserReset {
  Code: string;
  UserName: string;
  Password: string;
  ConfirmPassword: string;
}
export class UserChangePass {
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}
export class ConfirmaMailParams {
  userId: string;
  code: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/user.model.ts